import { Button as BackButton } from 'Components/Buttons/Button'
import styled from 'styled-components'

export const WatermarkContainer = styled.div`
  position: absolute;
  left: 40%;
  display: flex;
  top: 55%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
`
export const WatermarkText = styled.div`
  font-family: ${props => props.theme.fonts.robotoMedium};
  font-size: 30vh;
  align-self: flex-end;
  color: lightgrey;
  opacity: 0.1;
`

export const Container = styled.div`
  position: absolute;
  left: 40%;
  z-index: 0;
  top: 50%;
  text-align: center;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
`

export const Code = styled.div`
  color: ${props => props.theme.colors.primary};
  text-align: center;
  font-family: ${props => props.theme.fonts.robotoMedium};
  font-size: 62px;
`

export const Title = styled.div`
  color: ${props => props.theme.colors.secondary};
  text-align: center;
  margin-bottom: 10px;
  font-family: ${props => props.theme.fonts.robotoRegular};
  font-size: 32px;
`

export const Description = styled.div`
  text-align: center;
  color: ${props => props.theme.colors.secondary};
  opacity: 0.7;
  white-space: pre-wrap;
  filter: alpha(opacity=70); /* For IE8 and earlier */
  font-family: ${props => props.theme.fonts.robotoRegular};
  font-size: 16px;
`

export const Button = styled(BackButton)`
  max-width: 220px;
  display: inline-block !important;
  text-align: center;
  margin-top: 20px;
`



// WEBPACK FOOTER //
// ./src/Components/Page/HttpError/style.js